export default __webpack_public_path__ + "static/media/milestone 3400.ceb99012.svg";